import { FC } from 'react'

import { SegmentedControl as MantineSegmentedControl } from '@mantine/core'
import styled from 'styled-components'

import { colors } from 'src/Helpers/constants'

const StyledSegmentedControl = styled(MantineSegmentedControl)`
  background-color: ${colors.mainGray};
  border-radius: 8px;
  padding: 4px;

  .mantine-SegmentedControl-indicator {
    background-color: white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
  }

  .mantine-SegmentedControl-label {
    color: ${colors.thirdGray};
    font-weight: 500;
    font-size: 14px;
    padding: 8px 16px;
    transition: color 0.2s ease;

    &[data-active] {
      color: ${colors.thirdBlue};
      font-weight: 600;
    }
  }
`

export interface SegmentedControlOption {
  label: string | React.ReactNode
  value: string
}

export interface SegmentedControlProps {
  value: string
  onChange: (value: string) => void
  data: SegmentedControlOption[]
  fullWidth?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export const SegmentedControl: FC<SegmentedControlProps> = ({
  value,
  onChange,
  data,
  fullWidth = false,
  size = 'sm',
}) => {
  return (
    <StyledSegmentedControl
      value={value}
      onChange={onChange}
      data={data}
      fullWidth={fullWidth}
      size={size}
    />
  )
}
